import { useEffect, useState } from 'react';
import { accountLocale } from '../../i18n';
import { recallStudioDocument, rememberStudioDocument, studioOwner } from './studio-store';

export interface StudioDocumentOptions {
  /** Ответ переживает уход из раздела (studio-store, по владельцу): возврат рисуется из него сразу, запрос подтверждает его в фоне */
  remember?: boolean;
}
export function useStudioDocument<T>(load: (signal: AbortSignal) => Promise<T>, identity: string, { remember = false }: StudioDocumentOptions = {}) {
  const [revision, setRevision] = useState(0);
  const key = JSON.stringify([identity, revision]);
  const [state, setState] = useState<{ key: string; data?: T; error: boolean }>(() => {
    const kept = remember ? recallStudioDocument<T>(identity) : undefined;
    return kept === undefined ? { key: '', error: false } : { key, data: kept, error: false };
  });
  useEffect(() => {
    const controller = new AbortController();
    // ответ, пришедший уже другому владельцу или после смены языка, в память раздела не ложится
    const owner = studioOwner(),
      locale = accountLocale();
    void load(controller.signal)
      .then(data => {
        if (controller.signal.aborted) return;
        setState({ key, data, error: false });
        if (remember && owner === studioOwner() && locale === accountLocale()) rememberStudioDocument(identity, data);
      })
      .catch(() => {
        if (controller.signal.aborted) return;
        // ответ из памяти остаётся на месте, если подтверждение не пришло: сбой — только у ключа без данных
        setState(current => (current.key === key && current.data !== undefined ? current : { key, error: true }));
      });
    return () => controller.abort();
    // Загрузчик определяется ключом ресурса, а не ссылкой функции из render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  return {
    data: state.key === key ? state.data : undefined,
    error: state.key === key && state.error,
    loading: state.key !== key,
    reload: () => setRevision(value => value + 1),
  };
}
